export default __webpack_public_path__ + "static/media/Horisontal standard.02b3d4b8.svg";